import * as React from 'react';

function MotorRacing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.17 4c-2.968.208-4.34 1.163-5.016 1.631-.66.469-1.649 1.371-2.273 2.187.381.295 1.04.78 1.787 1.041 1.163.417 3.124.52 3.141.52l.746.035-1.84 4.096-.26.052c-.104.017-2.62.468-3.661.468-.729 0-2.013-.208-2.586-.312C3.035 14.69 3 15.627 3 16.442c0 1.389.139 2.378.139 2.378s2.69-.677 5.362-.677l8.66.295s3.609-4.113 3.609-8.07c0-.745-.121-1.492-.434-2.203C18.55 4.174 14.106 4 13.308 4h-.139zm-4.166 8.59l1.024-2.256c-.729-.07-1.874-.226-2.707-.503a7.158 7.158 0 01-2.048-1.198c-.277.417-.555.85-.833 1.32a9.742 9.742 0 00-1.04 2.776c.554.104 1.752.295 2.394.295.763 0 2.534-.295 3.21-.434zm4.39-.434c-.78 0-1.44-.642-1.44-1.44 0-.798.66-1.44 1.44-1.44.799 0 1.458.642 1.458 1.44 0 .798-.659 1.44-1.457 1.44z"
        fill="currentColor"
      />
    </svg>
  );
}

export default MotorRacing;
